import { ROLES } from '@/models/Rolle';
import GwrDatenView from '@/views/auth/datenimport/gebaeude/gwr_daten/IndexView.vue';
import AngrenzendeGebView from '@/views/auth/datenimport/gebaeude/angrenzende_geb/IndexView.vue';
import GrossverbraucherView from '@/views/auth/datenimport/gebaeude/grossverbraucher/IndexView.vue';
import EingespeisteEnergieView from '@/views/auth/datenimport/produktion/eingespeiste_energie/IndexView.vue';
import ProduktionseinheitenView from '@/views/auth/datenimport/produktion/produktionseinheiten/IndexView.vue';
import SolarstromanlagenView from '@/views/auth/datenimport/produktion/solarstromanlagen/IndexView.vue';

export default [
    {
        path: '/datenimport/gebaeude',
        meta: {
            requiresAuth: true,
            roles: [ROLES.datenimport],
        },
        children: [
            {
                path: 'gwr_daten',
                name: 'di_geb_gwr_daten',
                component: GwrDatenView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.datenimport],
                },
            },
            {
                path: 'angrenzende_geb',
                name: 'di_geb_angrenzende_geb',
                component: AngrenzendeGebView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.datenimport],
                },
            },
            {
                path: 'grossverbraucher',
                name: 'di_geb_grossverbraucher',
                component: GrossverbraucherView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.datenimport],
                },
            },
        ],
    },
    {
        path: '/datenimport/produktion',
        meta: {
            requiresAuth: true,
            roles: [ROLES.datenimport],
        },
        children: [
            {
                path: 'eing_energ',
                name: 'di_prod_eingespeiste_energie',
                component: EingespeisteEnergieView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.datenimport],
                },
            },
            {
                path: 'prod_einheiten',
                name: 'di_prod_produktionseinheiten',
                component: ProduktionseinheitenView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.datenimport],
                },
            },
            {
                path: 'solarstromanlagen',
                name: 'di_prod_solarstromanlagen',
                component: SolarstromanlagenView,
                meta: {
                    requiresAuth: true,
                    roles: [ROLES.datenimport],
                },
            },
        ],
    },
];

